import React from 'react'
import type { ValidationSummary } from '../../model/types'
import styles from './ImportSummary.module.css'

interface Props {
  summary: ValidationSummary
  fileName?: string
}

/** Header strip showing file name + counts (적용 가능 / 미매칭 / 오류). */
export const ImportSummary: React.FC<Props> = ({ summary, fileName }) => (
  <div className={styles.container}>
    {fileName && (
      <div className={styles.fileName} title={fileName}>
        파일: {fileName}
      </div>
    )}
    <div className={styles.counts}>
      <span className={styles.countItem}>
        총 <strong>{summary.total}</strong>건
      </span>
      <span className={`${styles.countItem} ${styles.valid}`}>
        적용 가능 <strong>{summary.valid}</strong>건
      </span>
      <span className={`${styles.countItem} ${styles.unmatched}`}>
        미매칭 <strong>{summary.unmatched}</strong>건
      </span>
      <span className={`${styles.countItem} ${styles.error}`}>
        오류 <strong>{summary.error}</strong>건
      </span>
    </div>
  </div>
)
